<template>
	<div class="qscode-box">
		<div class="title">
			<!-- 恭喜报名成功 -->
		</div>
		<div class="center">
			<div class="text-t">
				我是您本次学习的带班老师，请尽快添加老师微信，给您开通学习权限。
			</div>
			<div class="code-img">
				<img :src="info.teacherCode" mode="aspectFit"></img>
				<!-- <u-image width="460rpx" height="460rpx" :src="info.teacherCode" border-radius="8">
					<div class="banner-empty" slot="error">
						<image style="width: 460rpx;height: 460rpx;" :src="imgsrc('/static/imgs/banner_empty_logo_icon.png')" mode="aspectFit"></image>
					</div>
				</u-image> -->
			</div>
			<div class="tishi">
				长按识别二维码
			</div>
		</div>
		<div class="logo">
			<img src="@/assets/logo-max.png" mode="aspectFit"></img>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				info:{}
			}
		},
		created() {
			this.$API.productDetail(this.$route.params).then(res => {
				this.info = res.data
			})
		}
	}
</script>

<style style lang="stylus" rel="stylesheet/stylus">
	.qscode-box {
		.title {
			font-size: 0.39rem;
			padding-left: 0.65rem;
			padding-top: 0.4rem;
			font-weight: bold;
		}

		.center {
			width: 4.6rem;
			margin: 0 auto;

			.text-t {
				font-size: 0.24rem;
				font-weight: bold;
				margin-top: 1rem;
				text-align: center;
			}

			.code-img {
				margin-top: 0.26rem;
				text-align: center
			}

			.tishi {
				text-align: center;
				font-size: 0.24rem;
				font-weight: bold;
				margin-top: 0.5rem;
			}
		}

		.logo {
			position: fixed;
			bottom: 0.75rem;
			width: 100%;
			text-align: center;

			img {
				width: 3rem;
			}
		}
	}
</style>
